import { useContext } from 'react';
import { ConfigContext } from './ConfigContextInstance';

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
}
export function useConfigSection(section) {
  const { config, isHydrated } = useConfig();

  const hasData = () => {
    switch (section) {
      case 'skills':
        return config.skills && config.skills.length > 0;
      case 'projects':
        return config.projects && config.projects.length > 0;
      case 'experience':
        return config.experience && config.experience.length > 0;
      case 'hobbies':
        return config.hobbiesSection?.items && config.hobbiesSection.items.length > 0;
      default:
        return true;
    }
  };

  return {
    data: config[section] || config,
    isLoaded: isHydrated && hasData(),
    isEmpty: hasData() === false,
  };
}